module.exports = __webpack_public_path__ + "static/media/rivemo-delivery.4395c0ad.svg";